import { render } from "./PdfViewModel2.vue?vue&type=template&id=380429d2&scoped=true"
import script from "./PdfViewModel2.vue?vue&type=script&lang=js"
export * from "./PdfViewModel2.vue?vue&type=script&lang=js"

import "./PdfViewModel2.vue?vue&type=style&index=0&id=380429d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380429d2"]])

export default __exports__